export default __webpack_public_path__ + "static/media/Click_Flow.4cbd0c01.wav";